import { combineReducers } from 'redux';

import page from './page/reducer';

export default combineReducers({
  page,
});



// WEBPACK FOOTER //
// ./src/pages/processeddocuments/state/reducer.js